/**
 * Non-component shared bits for the home "recent work" widgets. Kept out of
 * `recentWidgetParts.tsx` so that file exports only components (Fast Refresh /
 * `react-refresh/only-export-components`).
 */
import type { CSSProperties } from "react";

export const RECENT_LIMIT = 5;

// Per-row entrance offset so the list settles in rather than blinking on.
export const staggerStyle = (index: number): CSSProperties => ({
    animationDelay: `${index * 45}ms`,
    animationFillMode: "both",
});
